import { Button, Flex } from 'antd';
import { useNavigate } from 'react-router';
import BuoyIcon from '../assets/icons/BuoyIcon';

type NotFoundProps = {
  title?: string;
};

export default function NotFound({
  title = 'Sorry, page not found',
}: NotFoundProps) {
  const navigate = useNavigate();

  // TODO: Enable auth guard

  // const { keycloak } = useKeycloak();
  // const { role } = useAuth();

  // if (!keycloak.authenticated || !role) {
  //   return <Navigate to="/sign-in" />;
  // }

  return (
    <Flex
      align="center"
      justify="center"
      className="w-screen h-screen flex justify-center items-center relative"
    >
      <div className="text-center">
        <h2 className="flex items-center text-center justify-center gap-2 text-8xl text-primary/50">
          4
          <BuoyIcon
            width={65}
            height={65}
            className="animate-buoy_icon"
            pathClass="!fill-primary"
          />
          4
        </h2>
        <h4 className="text-primary text-xl font-semibold uppercase mt-4 mb-8">
          {title}
        </h4>
        <div>
          <Button
            className="bg-primary"
            type="primary"
            onClick={() => navigate('/')}
          >
            Back to Home
          </Button>
        </div>
      </div>
    </Flex>
  );
}
